import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Component representing a nav bar with the possibility to activate a nav item.
 */
class Nav extends React.Component
{
    static propTypes = {
        className: PropTypes.string,

        // The active nav item
        active: PropTypes.number
    };

    static defaultProps = {
        active: 0
    };

    render() {
        const {className, active, children} = this.props;
        const classes = classNames("cccu-navtop cccu-top", {[className]: className !== undefined});

        return (
            <div className={classes}>
                {React.Children.map(children, (child, key) =>
                    React.cloneElement(child, {
                        ...child.props,
                        className: classNames(child.props.className, {active: active === key}),
                        key
                    })
                )}
            </div>
        )
    }
}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/widgets/Nav.js